import apiClient, { setAuthToken } from './api.client';

const ensureAuth = () => {
  const tk = localStorage.getItem('token');
  if (tk) setAuthToken(tk);
};

const handleError = (err) => {
  if (err && err.response && err.response.status === 401) {
    const e = new Error('Unauthorized');
    e.status = 401;
    throw e;
  }
  throw err;
};

const OrderService = {
  fetchOrders: async ({ accountId, page = 1, size = 30 } = {}) => {
    try {
      ensureAuth();
      const params = {};
      if (accountId) params.accountId = accountId;
      params.page = page;
      params.size = size;
      const res = await apiClient.get('/orders', { params });
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getOrderById: async (id) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/orders/${id}`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  createOrder: async (data) => {
    try {
      ensureAuth();
      const res = await apiClient.post('/orders', data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  updateOrder: async (id, data) => {
    try {
      ensureAuth();
      const res = await apiClient.patch(`/orders/${id}`, data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  resolveOrder: async (id) => {
    try {
      ensureAuth();
      const res = await apiClient.patch(`/orders/${id}/resolve`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getAnalytics: async ({ accountId, from, to } = {}) => {
    try {
      ensureAuth();
      const params = {};
      if (accountId) params.accountId = accountId;
      if (from) params.from = from;
      if (to) params.to = to;
      const res = await apiClient.get('/orders/analytics/summary', { params });
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getReport: async ({ accountId, from, to, status, type, payment, tableId, search, page = 1, size = 30 } = {}) => {
    try {
      ensureAuth();
      const params = { page, size };
      if (accountId) params.accountId = accountId;
      if (from) params.from = from;
      if (to) params.to = to;
      if (status) params.status = status;
      if (type) params.type = type;
      if (payment) params.payment = payment;
      if (tableId) params.tableId = tableId;
      if (search) params.search = search;
      const res = await apiClient.get('/orders/report', { params });
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },
};

export default OrderService;
